import { RootState } from "redux/rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.mentalCheckList.loading;
export const selectErrorMessage = (state: RootState) =>
  state.mentalCheckList.error;
export const mentalCheckListDataResponse = (state: RootState) =>
  state.mentalCheckList.mentalCheckListResponse;
